import React from 'react';
import PropTypes from 'prop-types';
import userRoles from '../authorization/userRoles';

const RoleCellRenderer = ({ value }) => (
  <div>
    {value === userRoles.SUPER_USER && 'Super User'}
    {value === userRoles.POWER_USER && 'Power User'}
    {value === userRoles.USER && 'User'}
  </div>
);

RoleCellRenderer.propTypes = {
  value: PropTypes.string,
};

export default RoleCellRenderer;
